import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { Suspense } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import Fallback from "src/components/common/Fallback";
import store from "src/redux/store";
import theme from "src/styles/theme";
import "./App.css";
import AppRouter from "./router/AppRouter";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, refetchOnMount: false },
  },
});

const App = (): JSX.Element => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <Suspense fallback={<Fallback />}>
            <BrowserRouter>
              <AppRouter />
            </BrowserRouter>
          </Suspense>
        </Provider>
      </QueryClientProvider>
    </ThemeProvider>
  );
};

export default App;